// import {FC, useState, useEffect} from 'react'
// import {useFormik} from 'formik'
// import * as Yup from 'yup'
// import {createUser, getUserById} from '../core/_requests'
// import {unitListItem, currencyList} from '../../../../../../_metronic/helpers'
// import {errorToast, successToast} from '../../../../../../_metronic/helpers/components/Toaster'
// import {useQueryResponse} from '../core/QueryResponseProvider'
// import {useListView} from '../core/ListViewProvider'

// type Props = {
//   isUserLoading: boolean
//   user?: any
// }

// const editUserSchema = Yup.object().shape({
//   templateName: Yup.string().required('Template Name is required'),
//   priceData: Yup.array().of(
//     Yup.object().shape({
//       price: Yup.number().required('Price is required'),
//       unit: Yup.string().required('Unit is required'),
//       currency: Yup.string().required('Currency is required'),
//     })
//   ),
// })

// const RemarksModalForm: FC<Props> = ({user = {}, isUserLoading}) => {
//   const [priceData, setPriceData] = useState<any[]>([])

//   const [data, setData] = useState<any[]>([])
//   const {setItemIdForUpdate} = useListView()
//   const {refetch} = useQueryResponse()

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res: any = await getUserById('clients/101212/categories')
//         const resData = res
//         setData(resData)
//       } catch (error) {
//         console.error('Error fetching categories', error)
//       }
//     }
//     fetchCategories()
//   }, [])

//   useEffect(() => {
//     if (data && data.length) {
//       const dropdownData = data.map((eachData) => ({
//         label: eachData.name,
//         value: eachData.id,
//       }))
//       fetchPriceData(dropdownData)
//     }
//   }, [data])

//   const fetchPriceData = async (dropdownData: any[]) => {
//     try {
//       const promises = dropdownData.map(async (category) => {
//         if (!category.value) return []

//         const res: any = await getUserById(`categories/${category.value}/price`)
//         const resData = res

//         return resData.map((item: any) => ({
//           price: item.price,
//           currency: item.currency,
//           categoryId: item.categoryId,
//           itemId: item.itemId,
//           unit: item.unit,
//           category: category.label,
//           item: item.itemName,
//           structureId: '',
//           structureName: '',
//         }))
//       })

//       const allResults = await Promise.all(promises)
//       const mergedResults = allResults.flat()

//       setPriceData(mergedResults)
//     } catch (error) {
//       console.error('Error fetching price data', error)
//     }
//   }

//   const cancel = (withRefresh?: boolean) => {
//     if (withRefresh) {
//       refetch()
//     }
//     setItemIdForUpdate(undefined)
//   }

//   const formik = useFormik({
//     initialValues: {
//       templateName: '',
//       priceData: priceData,
//     },
//     enableReinitialize: true,
//     validationSchema: editUserSchema, // (we'll also update the schema below)
//     onSubmit: async (values, {setSubmitting}) => {
//       setSubmitting(true)
//       try {
//         const updatedPriceData = values.priceData.map((item) => ({
//           ...item,
//           structureId: values.templateName || '',
//           structureName: values.templateName || '',
//         }))

//         const payload = {
//           templateName: values.templateName,
//           priceData: updatedPriceData,
//         }
//         await createUser(payload.priceData.slice(0, 1), 'bulkPrice')
//         successToast('Added')
//         cancel(true)
//       } catch (ex: any) {
//         console.error(ex.response.data.data)
//         errorToast(ex.response.data.data ?? 'Something Went Wrong')
//       } finally {
//         setSubmitting(true)
//         // cancel(true)
//       }
//     },
//   })

//   const handleInputChange = (index: number, field: string, value: any) => {
//     const updated = [...formik.values.priceData]
//     updated[index][field] = value
//     formik.setFieldValue('priceData', updated)
//   }

//   return (
//     <div>
//       <h2>Category price table</h2>

//       <form onSubmit={formik.handleSubmit}>
//         <table style={{borderCollapse: 'collapse', width: '100%'}} cellPadding={10} cellSpacing={0}>
//           <thead>
//             <tr>
//               <th style={{border: '1px solid #ccc', padding: '8px'}}>Category</th>
//               <th style={{border: '1px solid #ccc', padding: '8px'}}>Item</th>
//               <th style={{border: '1px solid #ccc', padding: '8px'}}>Unit</th>
//               <th style={{border: '1px solid #ccc', padding: '8px'}}>Price</th>
//               <th style={{border: '1px solid #ccc', padding: '8px'}}>Currency</th>
//             </tr>
//           </thead>
//           <tbody>
//             {formik.values.priceData.length > 0 ? (
//               formik.values.priceData.map((row, index) => (
//                 <tr key={index}>
//                   <td style={{border: '1px solid #ccc', padding: '8px'}}>{row.category}</td>
//                   <td style={{border: '1px solid #ccc', padding: '8px'}}>{row.item}</td>
//                   <td style={{border: '1px solid #ccc', padding: '8px'}}>
//                     <select
//                       value={row.unit}
//                       onChange={(e) => handleInputChange(index, 'unit', e.target.value)}
//                     >
//                       <option value=''>Select Unit</option>
//                       {unitListItem.map((unit: any, idx: number) => (
//                         <option key={idx} value={unit.value}>
//                           {unit.label}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                   <td style={{border: '1px solid #ccc', padding: '8px'}}>
//                     <input
//                       type='number'
//                       value={row.price}
//                       onChange={(e) => handleInputChange(index, 'price', e.target.value)}
//                       style={{width: '100px'}}
//                     />
//                   </td>
//                   <td style={{border: '1px solid #ccc', padding: '8px'}}>
//                     <select
//                       value={row.currency}
//                       onChange={(e) => handleInputChange(index, 'currency', e.target.value)}
//                     >
//                       <option value=''>Select Currency</option>
//                       {currencyList.map((currency: any, idx: number) => (
//                         <option key={idx} value={currency.value}>
//                           {currency.label}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={5}
//                   style={{textAlign: 'center', border: '1px solid #ccc', padding: '8px'}}
//                 >
//                   No Data Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>

//         <div style={{marginBottom: '20px'}}>
//           <label style={{display: 'block', marginBottom: '8px'}}>Enter template name</label>
//           <input
//             type='text'
//             name='templateName'
//             value={formik.values.templateName}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             style={{
//               width: '300px',
//               padding: '8px',
//               border: '1px solid #ccc',
//               borderRadius: '4px',
//             }}
//           />
//           {formik.touched.templateName && formik.errors.templateName && (
//             <div style={{color: 'red', marginTop: '4px'}}>{formik.errors.templateName}</div>
//           )}
//         </div>
//         <div style={{marginTop: '20px'}}>
//           <button type='submit'>Save changes</button>
//         </div>
//       </form>
//     </div>
//   )
// }

// export default RemarksModalForm



import { FC, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { createUser, getUserById } from '../core/_requests'
import { unitListItem, currencyList } from '../../../../../../_metronic/helpers'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListView } from '../core/ListViewProvider'


// type Props = {
//   isUserLoading: boolean
//   user?: any
// }

type Props = {
  isUserLoading: boolean
  user?: any
  onClose?: () => void
}

const editUserSchema = Yup.object().shape({
  templateName: Yup.string().required('Template Name is required'),
  priceData: Yup.array().of(
    Yup.object().shape({
      price: Yup.number().required('Price is required'),
      unit: Yup.string().required('Unit is required'),
      currency: Yup.string().required('Currency is required'),
    })
  ),
})

const RemarksModalForm: FC<Props> = ({ user = {}, isUserLoading, onClose }) => {
  const [priceData, setPriceData] = useState<any[]>([])
  const [data, setData] = useState<any[]>([])
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res: any = await getUserById('clients/101212/categories')
        const resData = res
        setData(resData)
      } catch (error) {
        console.error('Error fetching categories', error)
      }
    }
    fetchCategories()
  }, [])

  useEffect(() => {
    if (data && data.length) {
      const dropdownData = data.map((eachData) => ({
        label: eachData.name,
        value: eachData.id,
      }))
      fetchPriceData(dropdownData)
    }
  }, [data])

  const fetchPriceData = async (dropdownData: any[]) => {
    try {
      const promises = dropdownData.map(async (category) => {
        if (!category.value) return []

        const res: any = await getUserById(`categories/${category.value}/price`)
        const resData = res

        return resData.map((item: any) => ({
          price: item.price,
          currency: item.currency,
          categoryId: item.categoryId,
          itemId: item.itemId,
          unit: item.unit,
          category: category.label,
          item: item.itemName,
          structureId: '',
          structureName: '',
        }))
      })

      const allResults = await Promise.all(promises)
      const mergedResults = allResults.flat()

      setPriceData(mergedResults)
    } catch (error) {
      console.error('Error fetching price data', error)
    }
  }

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
    onClose?.() // This will close the modal
  }

  const formik = useFormik({
    initialValues: {
      templateName: '',
      priceData: priceData,
    },
    enableReinitialize: true,
    validationSchema: editUserSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        // Use all items in the payload
        const updatedPriceData = values.priceData.map((item) => ({
          ...item,
          structureId: values.templateName || '',
          structureName: values.templateName || '',
        }))

        const payload = {
          templateName: values.templateName,
          priceData: updatedPriceData,
        }

        // Send all items in the payload
        await createUser(payload.priceData, 'bulkPrice')
        successToast('Added')
        cancel(true)
      } catch (ex: any) {
        console.error(ex.response?.data?.data || ex)
        errorToast(ex.response?.data?.data ?? 'Something Went Wrong')
      } finally {
        setSubmitting(false)
        cancel(true) // Add this line
      }
    },
  })

  const handleInputChange = (index: number, field: string, value: any) => {
    const updated = [...formik.values.priceData]
    updated[index][field] = value
    formik.setFieldValue('priceData', updated)
  }

  return (
    <div>
      <h2>Category price table</h2>

      <form onSubmit={formik.handleSubmit}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }} cellPadding={10} cellSpacing={0}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Category</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Item</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Unit</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Price</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Currency</th>
            </tr>
          </thead>
          <tbody>
            {formik.values.priceData.length > 0 ? (
              formik.values.priceData.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.category}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.item}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    <select
                      value={row.unit}
                      onChange={(e) => handleInputChange(index, 'unit', e.target.value)}
                    >
                      <option value=''>Select Unit</option>
                      {unitListItem.map((unit: any, idx: number) => (
                        <option key={idx} value={unit.value}>
                          {unit.label}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    <input
                      type='number'
                      value={row.price}
                      onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                      style={{ width: '100px' }}
                    />
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    <select
                      value={row.currency}
                      onChange={(e) => handleInputChange(index, 'currency', e.target.value)}
                    >
                      <option value=''>Select Currency</option>
                      {currencyList.map((currency: any, idx: number) => (
                        <option key={idx} value={currency.value}>
                          {currency.label}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={5}
                  style={{ textAlign: 'center', border: '1px solid #ccc', padding: '8px' }}
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div style={{ marginBottom: '20px', marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Enter template name</label>
          <input
            type='text'
            name='templateName'
            value={formik.values.templateName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{
              width: '300px',
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />
          {formik.touched.templateName && formik.errors.templateName && (
            <div style={{ color: 'red', marginTop: '4px' }}>{formik.errors.templateName}</div>
          )}
        </div>
        <div style={{ marginTop: '20px' }}>
          <button
            type='submit'
            disabled={formik.isSubmitting}
            style={{
              padding: '8px 16px',
              backgroundColor: 'black',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            {formik.isSubmitting ? 'Saving...' : 'Save changes'}
          </button>
          <button
            type='button'
            onClick={() => cancel(true)}
            style={{
              marginLeft: '10px',
              padding: '8px 16px',
              backgroundColor: '#e0e0e0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default RemarksModalForm